import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes, routesLists} from "../../../../../core/models/static/routes/app-routes";
import useAccessLevels from "../../../../hooks/use-access-levels";
import ReportsView from "./reports";
import DashboardView from "./dashboard";
import LookupAnalyticsView from "./lookup";
import LostSalesAnalyticsView from "./lost-sales";
import DashboardV2View from "./dashboard-v2";
import AnalyticsLogsViews from "./logs-v2";

const AnalyticsViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Checks the pathname of the url with each change of the url.
     * if the pathname was [accounting.base] then redirects the user to the credits view.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.analytics.base, exact: true})) {
            if (operatorAccessLevels.packages.dashboard.viewDashboards) {
                history.replace(routes.analytics.dashboards);
            } else if (operatorAccessLevels.packages.dashboard.systemWideDashboards) {
                history.replace(routes.analytics.systemDashboards);
            } else if (operatorAccessLevels.packages.dashboard.systemWideReports) {
                history.replace(routes.analytics.systemReports);
            } else if (operatorAccessLevels.packages.dashboard.lookupAnalytics) {
                history.replace(routes.analytics.lookup.base);
            } else if (operatorAccessLevels.packages.dashboard.lostSalesAnalytics) {
                history.replace(routes.analytics.lostSales.base);
            } else if (operatorAccessLevels.packages.dashboard.lookupLogs || operatorAccessLevels.packages.dashboard.lostSalesLogs) {
                history.replace(routes.analytics.logs.base);
            } else {
                history.replace(routes.analytics.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.dashboard.viewDashboards, operatorAccessLevels.packages.dashboard.lookupAnalytics, operatorAccessLevels.packages.dashboard.lookupLogs, operatorAccessLevels.packages.dashboard.lostSalesAnalytics, operatorAccessLevels.packages.dashboard.lostSalesLogs, operatorAccessLevels.packages.dashboard.systemWideDashboards, operatorAccessLevels.packages.dashboard.systemWideReports])

    return (
        <>
            <Switch>
                <Route path={routes.analytics.base} exact/>
                {
                    operatorAccessLevels.packages.dashboard.systemWideReports &&
                    <Route path={routes.analytics.systemReports} exact>
                        <ReportsView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.dashboard.systemWideDashboards &&
                    <Route path={routes.analytics.systemDashboards} exact>
                        <DashboardView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.dashboard.viewDashboards &&
                    <Route path={routes.analytics.dashboards} exact>
                        <DashboardV2View/>
                    </Route>
                }
                <Route path={routesLists.analyticsLogs} exact>
                    <AnalyticsLogsViews/>
                </Route>
                {
                    operatorAccessLevels.packages.dashboard.lookupAnalytics &&
                    <Route path={routesLists.analyticsLookup} exact>
                        <LookupAnalyticsView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.dashboard.lostSalesAnalytics &&
                    <Route path={routesLists.analyticsLostSales} exact>
                        <LostSalesAnalyticsView/>
                    </Route>
                }
                <Redirect to={routes.analytics.base.concat(routes.error.accessDeniedForSection)}/>
            </Switch>
        </>

    );
};

export default AnalyticsViews;
